<template>
  <div>
    <a-table size="small" :pagination="false" :columns="columns" row-key="id" :data-source="dataSource">
      <template slot="sourceId" slot-scope="text, record"> {{ `${sourceTypes[record.source_type].key}-${record.source_id}` || '--' }} </template>
      <template slot="sourceType" slot-scope="text, record"> {{ sourceTypes[record.source_type].label || '--' }} </template>
      <template slot="customTitle" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <span>{{ record.title }}</span>
          </template>
          <span>{{ record.title }}</span>
        </a-popover>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-badge v-if="correctionStatus[record.status]" :status="correctionStatus[record.status].status" :text="correctionStatus[record.status].label" />
      </template>
      <template slot="content" slot-scope="text, record">
        <div v-for="(value, key) in record.content" :key="key">
          <span v-if="key === 'completed_time'">完成时间: {{ value }}</span>
          <span v-else-if="key === 'resolved_time'">解决时间: {{ value }}</span>
          <span v-if="key === 'solver'">解决人: {{ value }}</span>
        </div>
      </template>
      <template slot="creator" slot-scope="text, record">{{ record.creator ? record.creator.nickname : '--' }}</template>
    </a-table>
    <a-button v-has="{ code: 'data:correction:add' }" v-tc="{ name: '添加数据修正' }" type="link" icon="plus" @click="onAdd"> 添加 </a-button>
    <data-correction-modal :display="visible" :source-id="sourceId" :source-data="formData" @close="close" />
  </div>
</template>

<script>
import DataCorrectionModal from '@/pages/data/components/DataCorrectionModal';
const columns = [
  {
    title: 'ID',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'sourceId' }
  },
  {
    title: '类型',
    width: 60,
    align: 'center',
    scopedSlots: { customRender: 'sourceType' }
  },
  {
    title: '标题',
    ellipsis: true,
    width: '20%',
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '修正内容',
    ellipsis: true,
    width: 240,
    scopedSlots: { customRender: 'content' }
  },
  {
    title: '备注',
    ellipsis: true,
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '状态',
    width: 80,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建人',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '更新时间',
    align: 'center',
    width: 180,
    key: 'updated_time',
    dataIndex: 'updated_time'
  }
];
const sourceTypes = {
  requirement: { label: '需求', key: 'PR' },
  issue: { label: '缺陷', key: 'BG' }
};
const correctionStatus = {
  processing: { label: '审核中', status: 'processing' },
  passed: { label: '通过', status: 'success' },
  failed: { label: '不通过', status: 'error' }
};
export default {
  components: { DataCorrectionModal },
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      sourceTypes,
      correctionStatus,
      visible: false,
      sourceId: null,
      formData: {}
    };
  },
  methods: {
    close(type = 'cancel') {
      this.formData = {};
      this.sourceId = null;
      this.visible = false;
      if (type !== 'cancel') {
        this.$emit('close', type);
      }
    },
    onAdd() {
      this.visible = true;
    }
  }
};
</script>
